export const endpoints = {
  optionsCollectionAll: (optionsCollectionId: number) => `code/optionsCollection/${optionsCollectionId}/all/options`,
  caseType: () => 'code/casetype/all/options',
  visibleForFields: () => 'code/fieldNodes/options'
};
